// extracted by mini-css-extract-plugin
module.exports = {"container":"promoHeader__container___1jYFu","logo":"promoHeader__logo___2CTiR","label":"promoHeader__label___2oGYm","live":"promoHeader__live___v44Mv"};